const $ = require('jquery');

window.onload = function () {
    const consent = Cookies.getCookieConsent();
    if (consent) {
    } else {
        $('.cookie-banner').addClass('active');
    }
};

export class Cookies {
    static acceptCookies(consent) {
        document.cookie = `cookieConsent=${JSON.stringify(consent)}; path=/; max-age=${30 * 24 * 60 * 60}`;

        $('.cookie-banner').removeClass('active');

        gtag('consent', 'update', {
            'ad_storage': consent.ad ? 'granted' : 'denied',
            'analytics_storage': consent.analytics ? 'granted' : 'denied',
            'ad_user_data': consent.analytics ? 'granted' : 'denied',
            'ad_personalization': consent.analytics ? 'granted' : 'denied'
        });

        window.dataLayer.push({
            'event': 'cookie_consent_update'
        });
    }

    static getUTMParams() {
        const params = {};
        location.search.substr(1).split('&').forEach(param => {
            const [key, value] = param.split('=');
            if (key.startsWith('utm_')) {
                params[key] = decodeURIComponent(value);
            }
        });
        return params;
    }

    static getCookieConsent() {
        const consentCookie = document.cookie.split('; ').find(row => row.startsWith('cookieConsent='));
        return consentCookie ? JSON.parse(consentCookie.split('=')[1]) : null;
    }

    static init() {
        const utmParams = Cookies.getUTMParams();
        if (Object.keys(utmParams).length > 0) {
            localStorage.setItem('utmParams', JSON.stringify(utmParams));
        }

        $(".btn-confirm-cookies-all").on("click", function(e) {
            e.preventDefault();

            $('.modal-cookies-settings').hide();
            $('.cookie-banner').addClass('active');
            $('.cookie-banner').slideUp({
                start: function () {
                    $(this).css({display: "flex"})
                }
            });
            Cookies.acceptCookies({analytics: true, ad: true});
        });

        $(".btn-reject-cookies").on("click", function(e) {
            e.preventDefault();

            $('.modal-cookies-settings').hide();
            $('.cookie-banner').addClass('active');
            $('.cookie-banner').slideUp({
                start: function () {
                    $(this).css({display: "flex"})
                }
            });
            Cookies.acceptCookies({analytics: false, ad: false});
        });

        $(".btn-confirm-cookies").on("click", function(e) {
            e.preventDefault();

            $('.modal-cookies-settings').hide();
            $('.cookie-banner').addClass('active');
            $('.cookie-banner').slideUp({
                start: function () {
                    $(this).css({display: "flex"})
                }
            });
            if($('.with-analytics').hasClass('active')) {
                Cookies.acceptCookies({analytics: true, ad: true});
            } else {
                Cookies.acceptCookies({analytics: false, ad: false});
            }
        });

        $(".btn-options-cookies").on("click", function(e) {
            e.preventDefault();
            $('.cookie-banner').removeClass('active');
            $('.modal-cookies-settings').addClass('active');
        });

        $(".modal-cookies-settings-save__reject-button, .modal-cookies-settings-close").on("click", function(e) {
            e.preventDefault();
            $('.modal-cookies-settings').removeClass('active');
            $('.cookie-banner').addClass('active');
        });

        $(".modal-cookies-settings-options-reject").on("click", function(e) {
            e.preventDefault();
            $(this).addClass('active');
            $(this).next().removeClass('active');
            $(this).parent().removeClass('active');
        });

        $(".modal-cookies-settings-option-button-agree").on("click", function(e) {
            e.preventDefault();
            $(this).addClass('active');
            $(this).prev().removeClass('active');
            $(this).parent().addClass('active');
        });
    }
}
